// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { MUST_SEARCH_AT_LEAST_ONE_VALUE } from 'errors'
import { convertDMStoDD } from 'helpers/coordsConversion'
import { castToFloat } from 'helpers/reduxFormFunctions'

import {
  assembleQuery,
  fetchASRsByQuery,
} from 'helpers/api'

const fetchData = ({ formValues }) => {
  // form must have at least one value
  // throws error message if false
  const searchBasis = []
  let hasValue = false

  if (formValues.asr) {
    hasValue = true
    searchBasis.push({
      value: formValues.asr,
      field: 'asr',
      operator: 'LIKE',
    })
  }

  // capture coords values
  const latitude = convertDMStoDD(formValues.latitude)
  const longitude = convertDMStoDD(formValues.longitude)

  // if the radius input is empty, then we'll be using
  // 1 as the default radius.
  const radius = (
    formValues.radius.length
      ? castToFloat(formValues.radius)
      : 1
  )

  // if we've got a latitude and a longitude, then we'll use the radius
  // from above to make a geosearch for asrs.
  if (latitude && longitude) {
    hasValue = true
    searchBasis.push({
      field: 'geosearch',
      latitude,
      longitude,
      operator: 'EQ',
      value: radius,
    })
  }

  if (!hasValue) {
    throw new Error(MUST_SEARCH_AT_LEAST_ONE_VALUE)
  }

  // creates a 2d search array and states that we want ASRs with
  // either status code of C or G.
  const search = [
    [...searchBasis,
      {
        value: 'C',
        field: 'statusCode',
        operator: 'EQ',
      },
    ],
    [...searchBasis,
      {
        value: 'G',
        field: 'statusCode',
        operator: 'EQ',
      },
    ],
  ]

  const query = [{
    field: 'search',
    value: search,
  }]

  return fetchASRsByQuery(assembleQuery(query))
}

export default fetchData
